/**
 * Formats a given tax identification number (SSN) into a UI-friendly format.
 * The format will be `XXX-XX-XXXX`.
 *
 * @param taxIdentificationNumber - The SSN to be formatted.
 * @returns The formatted SSN as a string, or null if the input is falsy.
 */
export function getUISsnFormat(taxIdentificationNumber: string) {
    if (taxIdentificationNumber) {
        const arrayInfo = Array.from(taxIdentificationNumber);
        arrayInfo.splice(3, 0, '-');
        arrayInfo.splice(6, 0, '-');
        const uiSsnFormat = arrayInfo.join('');
        return uiSsnFormat;
    }
    return null;
}

/**
 * Formats a given Social Security Number (SSN) by masking the first five digits
 * and returning only the last four digits. If the input is empty or null, it returns 'N/A'.
 *
 * @param {string} input - The SSN string to be formatted.
 * @returns {string} The formatted SSN with the first five digits masked, or 'N/A' if the input is empty.
 */
export function ssnFormat(input: string) {
    if (!input) {
        return 'N/A';
    }
    return '***' + input.slice(-4);
}
